// extracted by mini-css-extract-plugin
module.exports = {"createServiceModalPage":"CreateServiceModal_createServiceModalPage__LJ0AF"};